var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.72701 1.31338c.35004.37063.36156.93842.04546 1.32184l-.08585.0918L4.515 9.5H19c.55228 0 1 .44772 1 1 0 .51284-.38604.9355-.88338.99327L19 11.5H4.515l7.17162 6.77298c.37064.35005.41455.91625.12086 1.3171l-.08047.09654c-.35004.37063-.91625.41455-1.31709.12085l-.09654-.08046-9-8.5c-.09267-.0892-.16357-.18673-.21553-.29506l-.03635-.08586-.02368-.07288-.02486-.1122-.0115-.10668L1 10.5l.0031-.07935.01367-.1037.03665-.14024.01932-.05183a.98537.98537 0 01.08186-.15956l.03528-.05172.05293-.06682.07057-.0738 9-8.5c.40151-.3792 1.03442-.36112 1.41363.0404z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.72cc8704.svg";
export { ForwardRef as ReactComponent };